import { checkPermission } from '@/helpers/checkPermissions';

function canAccessConversation(rootGetters, data) {
  const me = rootGetters['organisation/me'];
  const permissionToViewUnassigned = checkPermission('list_others_assigned_conversations', rootGetters);
  const permissionToViewAssignedToOthers = checkPermission('list_unassigned_conversations', rootGetters);
  return (
    (me.id === data.activity.to_user_id) ||
    (permissionToViewUnassigned && !data.activity.to_user_id) ||
    (permissionToViewAssignedToOthers && data.activity.to_user_id)
  );
}

let conversationNumberResync;
let conversationMyResync;

function handleFolderChange(commit, dispatch, rootState, rootGetters, organisationId, data) {
  return;
  const me = rootGetters['organisation/me'];
  const conversationsCache = JSON.parse(JSON.stringify(rootGetters['chat/conversationFastReload']));

  // Find conversation in number cache
  const targetConversation = { ...conversationsCache[data.business_uid][data.activity.meta_data.old_folder].find(conversation => conversation.id === data.activity.conversation_id) };
  if (targetConversation) {
    delete targetConversation.hide;
    targetConversation.folder = data.activity.meta_data.new_folder;
    if (conversationsCache[data.business_uid][data.activity.meta_data.new_folder]) {
      let sortedCache = conversationsCache[data.business_uid][data.activity.meta_data.new_folder].push(targetConversation);
      // sort this upper array by 'message_sent_at'
      sortedCache = conversationsCache[data.business_uid][data.activity.meta_data.new_folder].sort((a, b) => b.message_sent_at - a.message_sent_at);
      // cut more that one page of elements
      if (sortedCache.length > 25) {
        sortedCache.length = 25;
      }
      // save changes to store
      const updateData = {
        numberId: data.business_uid,
        folder: data.activity.meta_data.new_folder,
        data: sortedCache,
      };
      dispatch('chat/updateConversationCache', updateData, { root: true });
    }
    // Also update 'my' cache if needed
    if (
      data.activity.to_user_id === me.id &&
      conversationsCache.my &&
      conversationsCache.my[data.activity.meta_data.new_folder]
    ) {
      let sortedCache = conversationsCache.my[data.activity.meta_data.new_folder].push(targetConversation);
      sortedCache = conversationsCache.my[data.activity.meta_data.new_folder].sort((a, b) => b.message_sent_at - a.message_sent_at);
      if (sortedCache.length > 25) {
        sortedCache.length = 25;
      }
      const updateData = {
        numberId: 'my',
        folder: data.activity.meta_data.new_folder,
        data: sortedCache,
      };
      dispatch('chat/updateConversationCache', updateData, { root: true });
    }

    // remove from old folder
    clearTimeout(conversationNumberResync);
    conversationNumberResync = setTimeout(() => {
      dispatch(
        'chat/silentFetchConversationsForInbox',
        {
          organisationId,
          filters: {
            businessId: data.business_uid,
            page: 1,
            limit: 25,
            folder: data.activity.meta_data.old_folder,
          },
        },
        { root: true },
      ).then((conversation) => {
        dispatch('chat/updateConversationCache', { data: conversation.data.data, numberId: data.business_uid, folder: data.activity.meta_data.old_folder }, { root: true });
      });
    }, 3000);
    // Also remove from 'my' old folder
    clearTimeout(conversationMyResync);
    conversationMyResync = setTimeout(() => {
      if (data.activity.to_user_id === me.id && conversationsCache.my && conversationsCache.my[data.activity.meta_data.old_folder]) {
        dispatch(
          'chat/silentFetchConversationsForInbox',
          {
            organisationId,
            filters: {
              page: 1,
              limit: 25,
              folder: data.activity.meta_data.old_folder,
              assignment: 'user_assigned',
            },
          },
          { root: true },
        ).then((conversation) => {
          dispatch('chat/updateConversationCache', { data: conversation.data.data, numberId: 'my', folder: data.activity.meta_data.old_folder }, { root: true });
        });
      }
    }, 3000);
  } else if (
    (
      (conversationsCache[data.business_uid] && conversationsCache[data.business_uid][data.activity.meta_data.new_folder]) ||
      (conversationsCache.my && conversationsCache.my[data.activity.meta_data.new_folder])
    ) &&
    canAccessConversation(rootGetters, data)) { // check if it maybe fits on the first page of target folder but only if cache for target folder exists and user has acces to specific chat
    // check if it is in the new_folder and only update the message if exists on the data object - this is a case when the conversation is in the open folder but on new message we fake the new and old folder to simulate folder change event so both actions can be done at once.
    let targetConversationNumber;
    try {
      targetConversationNumber = { ...conversationsCache[data.business_uid][data.activity.meta_data.new_folder].find(conversation => conversation.id === data.activity.conversation_id) };
    } catch { }
    let targetConversationMy;
    try {
      targetConversationMy = { ...conversationsCache.my[data.activity.meta_data.new_folder].find(conversation => conversation.id === data.activity.conversation_id) };
    } catch { }
    if (targetConversationNumber || targetConversationMy) {
      if (targetConversationNumber) {
        targetConversationNumber.folder = data.activity.meta_data.new_folder;
        targetConversationNumber.inbound_sent_at = data.message.sent_at;
        targetConversationNumber.last_message = data.message.body ? data.message.body : getMediaType(data.message.media_type);
        targetConversationNumber.message_direction = data.message.direction;
        targetConversationNumber.user_id = data.assigned_user_id;
      }
      if (targetConversationMy) {
        targetConversationMy.folder = data.activity.meta_data.new_folder;
        targetConversationMy.inbound_sent_at = data.message.sent_at;
        targetConversationMy.last_message = data.message.body ? data.message.body : getMediaType(data.message.media_type);
        targetConversationMy.message_direction = data.message.direction;
        targetConversationMy.user_id = data.assigned_user_id;
      }

      if (!targetConversationNumber && conversationsCache[data.business_uid] && conversationsCache[data.business_uid][data.activity.meta_data.new_folder]) {
        if (conversationsCache[data.business_uid][data.activity.meta_data.new_folder].unshift(targetConversationMy) > 25) {
          conversationsCache[data.business_uid][data.activity.meta_data.new_folder].length = 25;
        }
        const updateData = {
          numberId: data.business_uid,
          folder: data.activity.meta_data.new_folder,
          data: conversationsCache[data.business_uid][data.activity.meta_data.new_folder],
        };
        dispatch('chat/updateConversationCache', updateData, { root: true });
      }
      if (!targetConversationMy && conversationsCache.my && conversationsCache.my[data.activity.meta_data.new_folder]) {
        if (conversationsCache.my[data.activity.meta_data.new_folder].unshift(targetConversationNumber) > 25) {
          conversationsCache.my[data.activity.meta_data.new_folder].length = 25;
        }
        const updateData = {
          numberId: 'my',
          folder: data.activity.meta_data.new_folder,
          data: conversationsCache.my[data.activity.meta_data.new_folder],
        };
        dispatch('chat/updateConversationCache', updateData, { root: true });
      }
      return;
    }

    // Skip fetching conversation if there is no cache for it to land in
    if (
      !(conversationsCache[data.business_uid] && conversationsCache[data.business_uid][data.activity.meta_data.new_folder]) &&
      !(data.activity.to_user_id === me.id && conversationsCache.my && conversationsCache.my[data.activity.meta_data.new_folder])
    ) {
      return;
    }

    // Fetch conversation
    dispatch(
      'chat/fetchSingleConversation',
      {
        businessId: data.business_uid,
        conversationId: data.activity.conversation_id,
      },
      { root: true },
    )
      .then((conversation) => {
        if (conversation.data) {
          // update number cache
          if (
            conversationsCache[data.business_uid] &&
            conversationsCache[data.business_uid][data.activity.meta_data.new_folder]
          ) {
            let sortedCache = conversationsCache[data.business_uid][data.activity.meta_data.new_folder].push(conversation.data);
            // sort this upper array by 'message_sent_at'
            sortedCache = conversationsCache[data.business_uid][data.activity.meta_data.new_folder].sort((a, b) => b.message_sent_at - a.message_sent_at);
            // cut more that one page of elements
            if (sortedCache.length > 25) {
              sortedCache.length = 25;
            }
            // save changes to store
            const updateData = {
              numberId: data.business_uid,
              folder: data.activity.meta_data.new_folder,
              data: sortedCache,
            };
            dispatch('chat/updateConversationCache', updateData, { root: true });
          }
          // Also update 'my' cache if needed
          if (
            data.activity.to_user_id === me.id &&
            conversationsCache.my &&
            conversationsCache.my[data.activity.meta_data.new_folder]
          ) {
            let sortedCache = conversationsCache.my[data.activity.meta_data.new_folder].push(conversation.data);
            sortedCache = conversationsCache.my[data.activity.meta_data.new_folder].sort((a, b) => b.message_sent_at - a.message_sent_at);
            if (sortedCache.length > 25) {
              sortedCache.length = 25;
            }
            const updateData = {
              numberId: 'my',
              folder: data.activity.meta_data.new_folder,
              data: sortedCache,
            };
            dispatch('chat/updateConversationCache', updateData, { root: true });
          }
        }
      });
  }
}

function handleAssignmentActivity(dispatch, rootGetters, organisationId, data) {
  return;
  // Check if user has permission to see unassigned or assigned to others
  const conversationsCache = JSON.parse(JSON.stringify(rootGetters['chat/conversationFastReload']));
  const me = rootGetters['organisation/me'];

  // Change user_id in cache
  ['my', data.business_uid].forEach((numberId) => {
    ['open', 'done'].forEach((folder) => {
      if (conversationsCache[numberId] && conversationsCache[numberId][folder]) {
        const targetConversation = conversationsCache[numberId][folder].find(conversation => conversation.id === data.activity.conversation_id);
        if (
          targetConversation &&
          canAccessConversation(rootGetters, data) &&
          (
            (numberId === 'my' && me.id === data.activity.to_user_id) ||
            numberId !== 'my'
          )
        ) {
          targetConversation.user_id = data.activity.to_user_id;
          // update store
          const updateData = {
            numberId,
            folder,
            data: conversationsCache[numberId][folder],
          };
          dispatch('chat/updateConversationCache', updateData, { root: true });
        } else if (targetConversation) {
          // delete conversation - just resync with backend
          const filters = {
            page: 1,
            limit: 25,
            folder,
          };

          if (numberId === 'my') {
            filters.assignment = 'user_assigned';
          } else {
            filters.businessId = data.business_uid;
          }

          dispatch(
            'chat/silentFetchConversationsForInbox',
            {
              organisationId,
              filters,
            },
            { root: true },
          ).then((conversation) => {
            dispatch('chat/updateConversationCache', { data: conversation.data.data, numberId, folder }, { root: true });
          });
        } else if (
          !targetConversation &&
          me.id === data.activity.to_user_id &&
          numberId === 'my' // only my chats can be affected by assignment change so no need to update number folders
        ) {
          // add conversation
          dispatch(
            'chat/fetchSingleConversation',
            {
              businessId: data.business_uid,
              conversationId: data.activity.conversation_id,
            },
            { root: true },
          )
            .then((response) => {
              if (response.status === 200) {
                // add to number folder but check if it fits to my folder and only add if it does
                conversationsCache[numberId][folder].push(response.data);
                conversationsCache[numberId][folder].sort((a, b) => b.message_sent_at - a.message_sent_at);
                if (conversationsCache[numberId][folder].length > 25) {
                  conversationsCache[numberId][folder].length = 25;
                }
                const updateData = {
                  numberId,
                  folder,
                  data: conversationsCache[numberId][folder],
                };
                // update store
                dispatch('chat/updateConversationCache', updateData, { root: true });
              }
            });
        }
      }
    });
  });
}

function handleBlockedActivity(dispatch, rootGetters, organisationId, data, status) {
  return;
  const conversationsCache = JSON.parse(JSON.stringify(rootGetters['chat/conversationFastReload']));
  ['my', data.business_uid].forEach((numberId) => {
    ['open', 'done'].forEach((folder) => {
      if (conversationsCache[numberId] && conversationsCache[numberId][folder]) {
        const targetConversation = conversationsCache[numberId][folder].find(conversation => conversation.id === data.activity.conversation_id);
        if (targetConversation) {
          targetConversation.blocked = status;
          const updateData = {
            numberId,
            folder,
            data: conversationsCache[numberId][folder],
          };
          dispatch('chat/updateConversationCache', updateData, { root: true });
        }
      }
    });
  });
}

function handleConsent(dispatch, rootGetters, organisationId, data, status) {
  return;
  const conversationsCache = JSON.parse(JSON.stringify(rootGetters['chat/conversationFastReload']));
  ['my', data.business_uid].forEach((numberId) => {
    ['open', 'done'].forEach((folder) => {
      if (conversationsCache[numberId] && conversationsCache[numberId][folder]) {
        const targetConversation = conversationsCache[numberId][folder].find(conversation => conversation.id === data.activity.conversation_id);
        if (targetConversation) {
          targetConversation.contact.has_messaging_consent = status;
          const updateData = {
            numberId,
            folder,
            data: conversationsCache[numberId][folder],
          };
          dispatch('chat/updateConversationCache', updateData, { root: true });
        }
      }
    });
  });
}

// if conversation is not in the cache then add it and make sure it is removed from done folder
function addConversationToCache(dispatch, rootGetters, organisationId, data) {
  return;
  const conversationsCache = JSON.parse(JSON.stringify(rootGetters['chat/conversationFastReload']));
  ['my', data.business_uid].forEach((numberId) => {
    ['open', 'done'].forEach((folder) => {
      if (conversationsCache[numberId] && conversationsCache[numberId][folder]) {
        const targetConversation = conversationsCache[numberId][folder].find(conversation => conversation.id === data.activity.conversation_id);
        if (targetConversation) {
          const updateData = {
            numberId,
            folder,
            data: conversationsCache[numberId][folder],
          };
          dispatch('chat/updateConversationCache', updateData, { root: true });
        }
      }
    });
  });
}

export {
  addConversationToCache,
  handleFolderChange,
  handleAssignmentActivity,
  handleBlockedActivity,
  handleConsent,
};
